/* eslint-enable */
/* eslint-enable */

class AnimationRelatedSuccessCase {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleRelatedSuccessCase = this.sectionsContainer.querySelectorAll('.related-success-cases');
		
		if (!this.$moduleRelatedSuccessCase)
			return;
		
		this.$moduleRelatedSuccessCaseElements = [];
		this.$moduleRelatedSuccessCase.forEach(module => {
			this.$moduleRelatedSuccessCaseElements.push(module.querySelectorAll('.anima'));	
		});
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleRelatedSuccessCase.forEach((module, index) => {
			gsap.set(module, { opacity: 1});
	        gsap.set(this.$moduleRelatedSuccessCaseElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });	
		});
	}

	initAnimate(index) {
		this.moduleRelatedSuccessCase = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleRelatedSuccessCase[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleRelatedSuccessCaseElements[index], { clearProps: true });
			}
        });
    
        this.moduleRelatedSuccessCase.addLabel('step1');
        this.moduleRelatedSuccessCase.to(this.$moduleRelatedSuccessCase[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleRelatedSuccessCase.to(this.$moduleRelatedSuccessCaseElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationRelatedSuccessCase;